<ng-container *ngIf="user$ | async as user; else loadingTemplate">
  <div class="card flex-row flex-md-column">
    <div class="card-body d-flex flex-column justify-content-center">
      <astrobin-avatar [user]="user"></astrobin-avatar>
      <astrobin-username [user]="user"></astrobin-username>
      <astrobin-marketplace-feedback-widget
        [listing]="listing"
        [user]="user"
        class="d-block mt-3"
      ></astrobin-marketplace-feedback-widget>
    </div>

    <div class="card-footer flex-column align-items-start justify-content-evenly">
      <div class="joined-astrobin">
        <strong class="d-block d-md-inline">{{ "Joined AstroBin" | translate }}:</strong>
        <span>{{ user.dateJoined | localDate | timeago }}</span>
      </div>

      <div class="signup-country">
        <strong class="d-block d-md-inline">{{ "Sign-up country" | translate }}:</strong>
        <span>
          <ng-container *ngIf="listing.userSignupCountry; else unknownTemplate">
            {{ countryService.getCountryName(listing.userSignupCountry, translateService.currentLang) }}
          </ng-container>
        </span>
      </div>

      <div class="last-seen-in-country">
        <strong class="d-block d-md-inline">{{ "Last seen in" | translate }}:</strong>
        <span>
          <ng-container *ngIf="listing.userLastSeenInCountry; else unknownTemplate">
            {{ countryService.getCountryName(listing.userLastSeenInCountry, translateService.currentLang) }}
          </ng-container>
        </span>
      </div>

      <div class="listing-count">
        <strong class="d-block d-md-inline">{{ "Marketplace listings" | translate }}:</strong>
        <span>{{ user.marketplaceListingCount }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #unknownTemplate>
  {{ "Unknown" | translate }}
</ng-template>
